import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx } from 'react/jsx-runtime';
import { Fragment } from 'react';
import { Tooltip } from '../tooltip/tooltip.js';
import { useIsEllipsized } from './useIsEllipsized.js';

var useFullTextTooltip = function useFullTextTooltip(_ref) {
  var ref = _ref.ref,
      children = _ref.children,
      textValue = _ref.textValue,
      _ref$skipOverflowChec = _ref.skipOverflowCheck,
      skipOverflowCheck = _ref$skipOverflowChec === void 0 ? false : _ref$skipOverflowChec;
  var isEllipsized = useIsEllipsized(ref);
  var shouldWrapInTooltip = isEllipsized && !skipOverflowCheck;
  var Wrapper = shouldWrapInTooltip ? function (props) {
    return jsx(Tooltip, _objectSpread(_objectSpread({}, props), {}, {
      content: textValue !== null && textValue !== void 0 ? textValue : children
    }));
  } : Fragment;
  return {
    Wrapper: Wrapper,
    wrapperProps: {}
  };
};

export { useFullTextTooltip };